import { useForm, useFormState } from 'react-final-form';
import { Control as Component } from '@alfa-bank/site-control/control';
import type { IControlDeps, TMiddleware } from '@alfa-bank/site-control/models';
import { createWidget } from '@alfa-bank/site-util-create-widget';
import type { TConfig } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/capture-exception';

import type { TFormValues } from '../../models/form';
import type { IApiErrorResponse } from '../../helpers/api/models';

import { requestCode, confirmCode, start, requestVerifyPhoneCode } from './actions';
import type { IActionParams, IProps, TAction, TActions } from './models';
import { handleResponseApiErrorStatus } from './helpers/handle-response-api-error-status';

const teamConfig: TConfig = {
    packageName: 'sme-credit-authentication',
    teamName: 'sme-credits',
};

const actions: TActions = {
    request_code: requestCode,
    confirm_code: confirmCode,
    start,
    request_verify_phone_code: requestVerifyPhoneCode,
};

const useData = (): IActionParams => {
    const form = useForm<TFormValues>();
    const { values } = useFormState<TFormValues>({
        subscription: { values: true },
    });

    return {
        form,
        values,
    };
};

const middleware: TMiddleware<TAction> =
    ({ callback }) =>
    async ({ ...props }) => {
        const {
            form: { change },
        } = props;

        try {
            await callback({ ...props });
        } catch (error: unknown) {
            handleResponseApiErrorStatus(error as IApiErrorResponse, change);
        }
    };

/** Обработчик действий  */
export const Control = createWidget<IControlDeps, IProps>({
    actions,
    useData,
    teamConfig,
    middleware,
})(Component);
